import React from "react";
import './Notification.css'
function Notification() {
  return (
    <li>
      <a href="https://github.com/ajnanmvr/CPET-Frontend">
        <i className="fa-solid fa-circle-exclamation" />
        lorem lorem lorem <span>Click Here</span>
      </a>
    </li>
  );
}

export default Notification;
